module.exports = __webpack_public_path__ + "img/background-footer.0c371dae.png";